
<form #giftCardForm="ngForm" [ngClass]="{'_load-animate _load-active': loading}">


	<div class="_dialog-title">
		<div class="flex-grow-1">{{args.title | translate}}</div>
		<button mat-icon-button mat-dialog-close class="dialog-close-button">
			<mat-icon aria-label="Close Dialog">close</mat-icon>
		</button>
	</div>

	<div class="_dialog-content pt-2" [ngSwitch]="args.mode">

		<ng-container *ngSwitchCase="'set'">
			<div class="list-group">
				<a class="list-group-item list-group-item-action" *ngFor="let account of $storage.giftCards.accounts" (click)="selectAccount(account)">
					{{account.name}}
				</a>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'select'">

			<mat-form-field appearance="outline" class="display-block" *ngIf="giftCard.hideOTP">
				<mat-label>{{'_GIFTCARD.number' | translate}}</mat-label>
				<input [(ngModel)]="giftCard.pan" name="giftCardPan" matInput placeholder="{{'_GIFTCARD.number' | translate}}" type="tel" required
					   [pattern]="panPattern" [disabled]="loading">
				<mat-icon matSuffix accessible [attr.aria-label]="appService.translate('ACCESS.delete')" aria-hidden="false" role="button" (click)="giftCard.pan = null" *ngIf="giftCard.pan" >close</mat-icon>
			</mat-form-field>
			<div class="otp text-center mb-2">
				<div *ngIf="!giftCard.hideOTP">{{otpMessage? otpMessage : '_GIFTCARD.otp_required' | translate}}</div>
				<div *ngIf="!giftCard.hideOTP && otpMessage && otpMessageNumber">{{otpMessageNumber}}</div>
			</div>

			<mat-form-field appearance="outline" class="display-block" *ngIf="!giftCard.hideOTP">
				<mat-label>{{'_GIFTCARD.otp_alt' | translate}}</mat-label>
				<input [(ngModel)]="giftCard.otp" name="otp" matInput type="tel" required
					   [maxlength]="4" pattern="[0-9]*" [disabled]="loading">
			</mat-form-field>

			<mat-form-field appearance="outline" class="display-block" *ngIf="!giftCard.hideCVV">
				<mat-label>{{'_GIFTCARD.cvv' | translate}}</mat-label>
				<input [(ngModel)]="giftCard.cvv" name="cvv" matInput type="tel" required
					   pattern="[0-9]*" [disabled]="loading">
				<mat-icon matSuffix [attr.aria-label]="appService.translate('ACCESS.delete')" aria-hidden="false" role="button" (click)="giftCard.cvv = null" *ngIf="giftCard.cvv">close</mat-icon>
			</mat-form-field>

		</ng-container>
		<ng-container *ngSwitchCase="'amount'">

			<ul class="list-group">
				<li class="list-group-item list-group-item-info d-flex">
					<div class="flex-grow-1">{{'_GIFTCARD.balance' | translate}}</div>
					<div class="gift-card-balance-price">{{giftCard.balance | lcurrency}}</div>
				</li>
				<li class="list-group-item list-group-item-info d-flex">
					<div class="flex-grow-1">{{'PO.REMAINED_PAY' | translate}}</div>
					<div class="gift-card-balance-price">{{maxAmount | lcurrency}}</div>
				</li>
			</ul>
			<hr />
			<div>
				<mat-form-field appearance="outline" class="display-block">
					<mat-label>{{'_GIFTCARD.amount' | translate}}</mat-label>
					<input [(ngModel)]="giftCard.amount" name="splitamount" matInput type="number" min="1" [max]="maxAmount" pattern="[0-9]+([\.,][0-9]+)?" required>
					<mat-icon matSuffix (click)="giftCard.amount = null" accessible [attr.aria-label]="appService.translate('ACCESS.delete')" aria-hidden="false" role="button" *ngIf="giftCard.amount">close</mat-icon>
					<mat-hint style="color: #ff6e40" *ngIf="giftCard.amount">
						<div *ngIf="giftCard.amount < 1">
							{{appService.translate('INVALID_AMOUNT_MIN', args.minT)}}
						</div>
						<div *ngIf="giftCard.amount > args.maxAmount">
							{{appService.translate('INVALID_AMOUNT_MAX', args.maxT)}}
						</div>
					</mat-hint>
				</mat-form-field>
			</div>
		</ng-container>
	</div>

	<div class="_bottom-actions">
		<button
			type="submit"
			mat-flat-button color="primary"
			class="apply-gift-card rounded lg block"
			(click)="apply(giftCardForm)"
			[disabled]="loading || (!giftCard.hideOTP && !validCodeLength)"
			[ngClass]="{ 'disable-click': !giftCard.hideOTP && !validCodeLength }">
			{{args.actionTitle | translate}}
		</button>
		<ng-container *ngIf="!giftCard.hideOTP">
			<ng-container *ngIf="countdownValue$ | async as countdownValue">
				<div
					class="resend-code disable-click"
					accessible
				>
					{{'did_not_arrive_resend' | translate}}
					({{ countdownValue }})
				</div>
			</ng-container>
			<ng-container *ngIf="countdownDone">
				<div
					class="resend-code"
					(click)="checkGiftCard(true)"
					accessible
				>
					{{'did_not_arrive_resend' | translate}}
				</div>
			</ng-container>
		</ng-container>
	</div>
</form>
